import React from "react";
import { createRoot } from "react-dom/client";
import AircraftHistoryData from "./AircraftHistoryData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderAircraftHistoryData: unknown;
	}
}

export function renderAircraftHistoryData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<AircraftHistoryData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderAircraftHistoryData = renderAircraftHistoryData;
